// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="headerText">Delete Payment Method</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="paragraphText">
                There are existing payment schedules associated with this bank account which will be deleted
                if you proceed. Are you sure you want to delete this bank account and all of its schedules? </p>
            <div *ngFor="let paymentSchedule of data.paymentSchedules | slice:0:4"
                 class="HOA-flextable-component
                         HOA-flextable-component__cell-100
                         HOA-payment-schedule-hrule-last__parent">
                <div class="HOA-flex-component HOA-flextable-component__cell-100 u-mH4">
                    <div class="HOA-payment-schedule__cell
                                        HOA-flextable-component__cell--pV12
                                        HOA-flextable-component__cell-value"
                         tid="scheduleNickname"
                         id="scheduleNickname">
                        {{paymentSchedule.nickname}}
                    </div>
                </div>
            </div>
            <div *ngIf="data.paymentSchedules.length > 4"
                 class="HOA-flextable-component
                         HOA-flextable-component__cell-100
                         HOA-payment-schedule-hrule-last__parent">
                <div class="HOA-flex-component HOA-flextable-component__cell-100 u-mH4">
                    <div class="HOA-payment-schedule__cell
                                        HOA-flextable-component__cell--pV12
                                        HOA-flextable-component__cell-value">
                        <strong>+{{data.paymentSchedules.length - 4}} additional schedule
                            <span *ngIf="data.paymentSchedules.length > 5">s</span>
                        </strong>
                    </div>
                </div>
            </div>
            <p *ngIf="data.paymentSchedules > 4"></p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130"
                    tid="cancel"
                    (click)="closeThisDialog(0)">
                No
            </button>
            <button class="Button Button--blue Button--minWidth130"
                    tid="yes"
                    (click)="closeThisDialog('Delete')">
                Yes
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;